import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { filterResults } from '../../utils/functions';

const useStyles = makeStyles((theme) => ({
  filter: {
    minWidth: 548,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));

function AddressHistoryQuickFilterSearch(props) {
  const classes = useStyles();
  const { data, columns, setFilteredRows, duration, agencyFilter } = props;
  const [text, setText] = useState('');

  useEffect(() => {
    if (!data) return;
    let results = agencyfilterRows(data);
    if (text) {
      results = filterResults(text, results, columns);
    }

    let durationFiltered = [];
    switch (duration) {
      case 'Day':
        durationFiltered = results.filter((row) => receivedDate(row) > getDateSubDays(1));
        break;
      case 'Week':
        durationFiltered = results.filter((row) => receivedDate(row) > getDateSubDays(7));
        break;
      case 'Month':
        durationFiltered = results.filter((row) => receivedDate(row) > getDateSubDays(30));
        break;
      case 'Over-Month':
        durationFiltered = results.filter((row) => receivedDate(row) <= getDateSubDays(30));
        break;
      default:
        durationFiltered = results;
        break;
    }

    setFilteredRows(durationFiltered);

    // eslint-disable-next-line
  }, [text, data, duration, agencyFilter]);

  const receivedDate = (row) => new Date(row.Received);

  const getDateSubDays = (days) => {
    const result = new Date();
    result.setDate(result.getDate() - days);
    return result;
  };

  const quickFilter = (ev) => {
    const val = ev.target.value;
    setText(val);
  };

  const agencyfilterRows = (data) => {
    let filteredByAgency;
    switch (agencyFilter) {
      case 'filter-all':
        filteredByAgency = data;
        break;
      case 'filter-unassigned':
        filteredByAgency = data.filter((row) => !row.AgencyIDs.length);
        break;
      default:
        filteredByAgency = data.filter((row) => row.AgencyIDs.includes(agencyFilter));
        break;
    }
    return filteredByAgency;
  };

  return (
    <TextField
      label="Quick filter"
      type="search"
      className={classes.filter}
      variant="outlined"
      size="small"
      onChange={quickFilter}
      value={text}
    />
  );
}

export default AddressHistoryQuickFilterSearch;
